import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

const US_REGION = 'US';

/**
 * Same US parse Settings uses: invalid or unparseable input is not a number.
 * National format is what Settings writes after a successful blur.
 */
export const getIsValidPhone = (numToValidate: unknown): boolean => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    try {
        const parsedPhone = phoneUtil.parse(numToValidate as string, US_REGION);
        return phoneUtil.isValidNumber(parsedPhone);
    } catch (e) {
        return false;
    }
};

export const getFormattedPhone = (phone: unknown): string | null => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    try {
        const parsed = phoneUtil.parse(phone as string, US_REGION);
        return phoneUtil.format(parsed, PhoneNumberFormat.NATIONAL);
    } catch (e) {
        return null;
    }
};
